module.exports = __webpack_public_path__ + "static/media/shop.0b179d51.svg";